/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { accountsGetUsage } from "../../funcs/accountsGetUsage.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiLeadScraperMicroserviceApiV1AccountsIdUsageRequest$inboundSchema,
};

export const tool$accountsGetUsage: ToolDefinition<typeof args> = {
  name: "accounts_get-usage",
  description: `Get account usage

Retrieves usage details for a given account`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await accountsGetUsage(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
